import styles from './select.module.scss';
import Select, {GroupBase, Props} from 'react-select';

interface OwnProps {
    isLocked: boolean;
    isSearchable?: boolean;
    onChange?: (e: never) => void;
}

export function CustomSelect<
    Option,
    IsMulti extends boolean = false,
    Group extends GroupBase<Option> = GroupBase<Option>,
>(props: Props<Option, IsMulti, Group> & OwnProps) {
    return (
        <Select
            isSearchable={props.isSearchable ?? false}
            className={styles.select}
            styles={{
                control(base, state) {
                    return {
                        ...base,
                        borderRadius: '0px',
                        border: props.isLocked ? 'none !important' : 'none',
                        boxShadow: '0 !important',
                        borderBottom: state.isFocused
                            ? '1px solid var(--accent-color)'
                            : '1px solid var(--border-dark-color)',
                        background: state.isFocused ? 'var(--accent-lightest-color)' : 'transparent',
                        paddingLeft: state.isFocused ? '0.667rem' : '0',
                        paddingRight: state.isFocused ? '0.667rem' : '0',
                        fontSize: '1rem',
                        '&:hover': {
                            border: 'none',
                            borderBottom: '1px solid var(--accent-color)',
                        },
                    };
                },
                valueContainer(base) {
                    return {
                        ...base,
                        padding: 0,
                    };
                },
                singleValue(base) {
                    return {
                        ...base,
                        color: 'var(--text-color)',
                    };
                },
                indicatorSeparator(base) {
                    return {
                        ...base,
                        display: 'none',
                    };
                },

                dropdownIndicator(base) {
                    return {
                        ...base,
                        paddingRight: 0,
                        display: props.isLocked ? 'none' : 'block',
                    };
                },
                menu(base) {
                    return {
                        ...base,
                        padding: 0,
                        border: 'none',
                        borderRadius: 0,
                        background: 'var(--foreground-color)',
                        color: 'var(--text-color)',
                    };
                },
                menuList(base) {
                    return {
                        ...base,
                        background: 'var(--foreground-color)',
                        padding: 0,
                    };
                },
                option(base, state) {
                    return {
                        ...base,
                        background: state.isSelected
                            ? 'var(--accent-color)'
                            : state.isFocused
                              ? 'var(--accent-light-color)'
                              : 'var(--foreground-color)',
                        color: state.isSelected ? 'var(--white-color)' : 'var(--text-color)',
                    };
                },
            }}
            theme={(theme) => {
                return {
                    ...theme,
                    colors: {
                        ...theme.colors,
                        primary: 'var(--accent-color, red)',
                        primary25: 'var(--accent-light-color)',
                    },
                };
            }}
            {...props}
            onChange={props.onChange}
        />
    );
}
